const luna = {
    themeName: 'luna',
    brand: 'lunabet.io',
    font: {
        main: ['DM Sans', 'sans-serif'],
        alternative: ['Inter', 'sans-serif'],
        'alternative-2': ['Poppins', 'sans-serif'],
        'alternative-3': ['Montserrat', 'sans-serif']
    },
    color: {
        primary: {
            '100': '#f564b4',
            '300': '#F9CE28',
            '500': '#F9CE28',
            '700': '#F9CE28',
            '900': '#8E0550'
        },
        secondary: {
            '100': '#2A2A2A',
            '300': '#18192F',
            '500': '#2C2853',
            '700': '#18192F',
            '900': '#18192F'
        },
        tertiary: {
            '100': '#18192F',
            '300': '#18192F',
            '500': '#2C2853',
            '700': '#10121F',
            '900': '#18192F'
        },
        accent: {
            '100': '#FFFFFF',
            '300': '#D4D4D4',
            '500': '#A3A3A3',
            '700': '#F9CE28',
            '900': '#18192F'
        },
        neutral: {
            '100': '#FFFFFF26',
            '300': '#FFFFFF33',
            '500': '#FFFFFF0D',
            '700': '#FFFFFF1A',
            '900': '#2C2853'
        },
        background: {
            '100': '#18192F',
            '300': '#18192F',
            '500': '#18192F',
            '700': '#18192F',
            '900': '#18192F'
        },
        success: {
            '100': '#FFF4CC',
            '300': '#FBE487',
            '500': '#F5DB53',
            '700': '#E3C100',
            '900': '#8C6F00'
        },
        warning: {
            '100': '#B9FBD7',
            '300': '#7DF2AF',
            '500': '#01D180',
            '700': '#019B61',
            '900': '#006B42'
        },
        error: {
            '100': '#F8C5C5',
            '300': '#E67777',
            '500': '#CC2B2B',
            '700': '#991E1E',
            '900': '#5A0E0E'
        },
        info: {
            '100': '#D7E9FA',
            '300': '#89C3F2',
            '500': '#2C92CB',
            '700': '#1C5F8A',
            '900': '#0B2C40'
        },
        text: {
            '100': '#FFFFFF',
            '300': '#D4D4D4',
            '500': '#A3A3A3',
            '700': '#F9CE28',
            '900': '#000000'
        },
        highlight: {
            '1': '#F9CE28',
            '2': '#F9CE28',
            '3': '#ffffff26',
            '4': 'transparent',
            '5': '#3353F9'
        }
    },
    gradients: {
        main: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        alternative: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-3': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.500', at: '100%' }
            ]
        },
        'alternative-4': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.500', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-5': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.500', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-6': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        primary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        'primary-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        'primary-dark': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        secondary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.500', at: '0%' },
                { token: 'color.secondary.700', at: '100%' }
            ]
        },
        'secondary-light': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        accent: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.accent.300', at: '0%' },
                { token: 'color.accent.500', at: '100%' }
            ]
        },
        success: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.success.500', at: '0%' },
                { token: 'color.success.900', at: '100%' }
            ]
        },
        error: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.500', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        'error-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.300', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        christmas: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.2', at: '0%' },
                { token: 'christmas.1', at: '100%' }
            ]
        },
        'christmas-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.3', at: '0%' },
                { token: 'christmas.4', at: '100%' }
            ]
        }
    },
    borderRadius: {
        button: { default: '8px', small: '8px' },
        input: { default: '12px', message: '8px' },
        header: { chatNotifications: '8px', profile: '24px', toggle: '50%', vip: '41px' },
        promotions: { item: '8px' }
    },
    components: {
        error: { background: 'color.error.500', text: 'color.text.100' },
        footer: { social: 'color.background.700' },
        info: { background: 'color.info.500', text: 'color.text.100' },
        input: {
            background: 'color.background.500',
            border: 'transparent',
            'border-hover': 'transparent',
            'border-active': 'transparent'
        },
        progress: {
            background: 'color.background.500',
            'background-2': 'color.background.900',
            fill: 'color.primary.500',
            'fill-2': 'color.highlight.2',
            'fill-2-shadow': 'color.highlight.2',
            'fill-shadow': 'color.primary.500'
        },
        success: { background: 'color.success.500', text: 'color.text.900' },
        table: { 'odd-row': '#222040' },
        warning: { background: 'color.warning.500', text: 'color.text.900' },
        sportmodity: {
            background: '#0F111D',
            foreground: 'color.text.100',
            primary: 'color.primary.500',
            'primary-foreground': 'color.text.900',
            selection: 'color.primary.500',
            'selection-foreground': 'color.text.900',
            outcome: 'color.neutral.700',
            'outcome-foreground': 'color.text.100',
            card: 'color.neutral.500',
            'card-foreground': 'color.text.100',
            border: 'color.neutral.700',
            radius: 'borderRadius.button.default',
            accent: 'color.accent.500',
            success: 'color.success.500',
            warning: 'color.warning.500',
            error: 'color.error.500'
        },
        'home-page': {
            'text-banner01': {
                'cta-button-bg': '#FFCD2A',
                'cta-button-text': '#0D0F19',
                'status-dot-bg': '#4EFF2A',
                'banner-title-highlight': '#FFCD2A'
            },
            'text-banner02': {
                'btn1-bg': '#5D48DA',
                'btn2-bg': '#FFCD2A',
                'card1-bg-from': '#FFCD2A',
                'card1-bg-to': '#CFAA34',
                'card2-bg-from': '#5D48DA',
                'card2-bg-to': '#312674'
            }
        },
        'banner-swiper': {
            'banner-fixed': {
                'regular-color': '#FFCD2A',
                'text-light': '#FFFFFF',
                'text-dark': '#0F121E',
                'sub01-bg': '#DA4A48',
                'sub02-bg': '#5D48DA'
            }
        },
        layout: {
            'body-bg': '#0F111D',
            'side-bar-bg': '#1F203B',
            'footer-bg': '#0D0F1A'
        },
        'side-bar': {
            'dropdown-sport-active-bg': '#5C47D6',
            'dropdown-sport-active-text': '#FFFFFF',
            'dropdown-casino-active-bg': '#5C47D6',
            'dropdown-casino-active-text': '#FFFFFF',
            'dropdown-side-bar-item-bg': '#2A2B45'
        },
        cashier: {
            'dropdown-panel-bg': '#0F111D'
        },
        'vip-dashboard': {
            'your-rank': {
                //--component-vip-dashboard-your-rank-*
                'card-bg': 'color.background.500',
                'text-primary': 'white',
                'rank-text': '#ccdee6',
                surface: '#292649',
                'label-muted': 'white',
                'bar-bg': '#121632',
                'bar-from': 'color.primary.500',
                'bar-to': '#E28713',
                'label-dim': 'white',
                'label-above': '#5c5c5c',
                'reward-text': 'color.primary.500'
            },
            'all-ranks': {
                //--component-vip-dashboard-all-ranks-*
                'card-bg': 'color.background.500',
                'text-primary': 'white',
                'rank-text': '#ccdee6',
                'bar-from': 'color.primary.500',
                'bar-to': '#E28713',
                'label-muted': '#848484',
                'progress-bg': '#303030'
            },
            modal: {
                //--component-vip-dashboard-modal-*
                'body-bg': '#0F111D'
            }
        },
        'about-vip': {
            //--component-about-vip-vip-rank-rewards-*
            'vip-rank-rewards': {
                'odd-row-bg': 'color.background.500',
                'table-header-bg': '#0F111D',
                'table-side-bg': '#0F111D'
            }
        }
    },
    boxShadows: {
        neutral: '0px 5px 6px 0px #00000040 inset, 0px -5px 6px 0px #FFFFFF16 inset',
        inner: '0px 0px 8px 0px #00000099',
        vip: '0px 0px 8px 0px #ffffff7a'
    },
    maxHeight: { zero: '0', full: '100%' },
    transitions: { maxHeight: 'max-height', rotate: 'transform' },
    rotate: { '360': '360deg' },
    width: { fitContent: 'fit-content', width15: '3.70rem', chatWidth: '240px' },
    height: { height15: '3.70rem' },
    screens: { xs390: '390px', customSm: '580px', custom720: '720px' },
    christmas: {
        '1': '#B00404',
        '2': '#FD5757',
        '3': '#FED234',
        '4': '#FF952B',
        '5': '#61370D',
        '6': '#FF9E14',
        '7': '#0F2985'
    },
    vip: { '1': 'color.highlight.3', '2': 'color.highlight.3' }
};
export default luna;
